module.exports = function(bootstrap) {
    bootstrap.run(["Service","$filter", function (Service,$filter) {
        return new Service({
            name: 'claimDetailsSupplement',
            group: "rbsmbl",
            url: "/rbsmbl/x-services/asp/claims/detail",
            cache: true,
            fetch: function(claim, claimSupplementData, agreementId){

                // Subscriber ID for 17 bytes
                // Claim number for 11 bytes
                // PIN for 3 bytes
                var claimKey = agreementId.substr(0,9);
                while (claimKey.length < 17) {
                    claimKey += " ";
                }
                claimKey = claimKey + claim.claimNumber;
                while (claimKey.length < 28) {
                    claimKey += " ";
                }
                claimKey = claimKey + claim.famUnitIndividualIdenNo;
                while (claimKey.length < 31) {
                    claimKey += " ";
                }

                return this.get({
                    claimKey: claimKey,
                    claimSrc: claimSupplementData.claimSrc,
                    contractId: agreementId,
                    datesOfSvc: claimSupplementData.svcBeginDte,
                    providerId: claimSupplementData.provNum
                });
            }
        });
    }]);
};
